import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { buildFeesChargedRequest, buildFeesView, type FeesDateRange, getFeesCharged } from '@/services/api/risk-fees';

export const RISK_FEES_QUERY_KEY = ['risk', 'fees'] as const;

// `buildFeesView` is a stable module-level select — an inline closure recreated
// per render would defeat TanStack Query's select memoization and re-run the
// full per-day-per-currency pivot on every render.
export const collectedFeesQueryOptions = (range: FeesDateRange) =>
  queryOptions({
    queryKey: [...RISK_FEES_QUERY_KEY, range.from, range.to],
    queryFn: () => getFeesCharged(buildFeesChargedRequest(range)),
    select: buildFeesView,
    // Update with a new range keeps the existing chart/table on screen until the
    // new data lands — only the button shows a loading state.
    placeholderData: keepPreviousData,
  });

export const useCollectedFees = (range: FeesDateRange) => useQuery(collectedFeesQueryOptions(range));
